<template>
  <div class="owner-patients-information-completion">
    <div class="page-title">
      <base-page-title>{{
        $t('ownerPatientsInformationCompletion.pageTitle')
      }}</base-page-title>
    </div>
    <div class="owner-patients-progress-bar">
      <progress-bar v-bind="progressBarData" />
    </div>
    <div class="check-mark"><base-check-mark /></div>
    <div class="message">
      <div class="message-p1">
        <span>{{
          $t('ownerPatientsInformationCompletion.textChangeCompleted')
        }}</span>
      </div>
      <div class="message-p2">
        <span>{{ $t('ownerPatientsInformationCompletion.textMailSent') }}</span>
        <div v-if="clinic.contactTelShowFlg === 1">
          <span>{{ $t('common.textIfNoEmail') }}</span>
        </div>
      </div>
      <div class="message-p3" v-if="clinic.contactTelShowFlg === 1">
        <span>{{ contact }}</span>
      </div>
    </div>
    <div class="menu-button">
      <base-decision-button @click="pushToReservationMenu">{{
        $t('common.buttonMenu')
      }}</base-decision-button>
    </div>
  </div>
</template>

<script>
import BasePageTitle from '@/components/parts/atoms/BasePageTitle.vue'
import ProgressBar from '@/components/parts/organisms/ProgressBar.vue'
import BaseCheckMark from '@/components/parts/atoms/BaseCheckMark.vue'
import BaseDecisionButton from '@/components/parts/atoms/BaseDecisionButton.vue'
import PreventBack from '@/components/mixins/PreventBack'

export default {
  name: 'OwnerPatientsInformationCompletion',

  components: {
    BasePageTitle,
    ProgressBar,
    BaseCheckMark,
    BaseDecisionButton
  },

  mixins: [PreventBack],

  data() {
    return {
      progressBarData: {
        textList: [
          'common.progressBarModifyOwner',
          'common.progressBarConfirm',
          'common.progressBarFinish'
        ],
        barWidthPc: 'owner-info-edit-screen',
        textOrangeNumber: 3
      }
    }
  },

  computed: {
    clinic() {
      return this.$store.getters['clinic/getClinic']
    },
    contact() {
      return this.$i18n.locale === 'en'
        ? `${this.clinic.nameEnglish || this.clinic.name}: ${
            this.clinic.contactTel
          }`
        : `${this.clinic.name}：${this.clinic.contactTel}`
    }
  },

  methods: {
    pushToReservationMenu() {
      this.$router.push({ name: 'ReservationMenu' })
    }
  }
}
</script>

<style lang="scss" scoped>
.owner-patients-information-completion {
  margin-bottom: 100px;
  > .page-title {
    margin-top: 70px;
  }
  > .owner-patients-progress-bar {
    margin-top: 28px;
  }
  > .check-mark {
    margin-top: 40px;
  }
  > .message {
    @include font-size(18);
    font-weight: bold;
    > .message-p1 {
      margin-top: 46px;
    }
    > .message-p2 {
      margin-top: 101px;
    }
    > .message-p3 {
      margin-top: 21px;
    }
  }
  > .menu-button {
    margin-top: 66px;
  }
}
@media (max-width: $global-media-width) {
  .owner-patients-information-completion {
    > .check-mark {
      margin-top: 84px;
    }
    > .message {
      max-width: 410px;
      width: calc-percent(410px, 640px);
      margin: 0 auto;
      > .message-p2 {
        margin-top: 53px;
        text-align: left;
      }
      > .message-p3 {
        text-align: left;
      }
    }
    > .menu-button {
      margin-top: 95px;
    }
  }
}
</style>
